/* eslint-disable */
define('banner/custom-banners/hub-rollout-banner',['require','durandal/app','web-urls','lib/auth/auth','react-banner-component'],function (require) {
    var app = require('durandal/app');
    var webUrls = require('web-urls');
    var auth = require('lib/auth/auth');
    var BannerComponent = require('react-banner-component');

    var token = auth.getToken();

    return {
        initialize: function (locale, engagementEngineResponse, bannerTelemetry) {
            var urls = {
                engagementEngineURL: webUrls.get('engagementEngineUrl'),
                telemetryServiceURL: webUrls.get('telemetryUrl'),
                hubRolloutApiURL: webUrls.get('hubRolloutApiUrl')
            };
            var hubRolloutBannerProps = Object.assign({
                client: "web",
                closeHandler: function () {
                    sessionStorage.setItem('bannerRemoved', 'true');
                },
                language: locale,
                linkClickHandler: function () {
                    sessionStorage.setItem('bannerRemoved', 'true');
                },
                telemetry: bannerTelemetry,
                userConfig: {
                    accountKey: engagementEngineResponse.accountKey,
                    token: token.access_token,
                    userKey: engagementEngineResponse.userKey
                },
                urls: urls
            });

            var hubRolloutBanner = {
                isReactComponent: true,
                ReactComponent: BannerComponent.HubRolloutBanner,
                ReactProps: hubRolloutBannerProps,
                removeOnNavigation: false
            };
            app.trigger('banner:addReact', hubRolloutBanner);
            bannerTelemetry.bannerDisplayed();
        }
    };
});

